<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('patients')"
      :columns="columns"
      :column_search="true"
      resource_url="/animal/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="go_calendar">
          <span class="icon"><i class="fa fa-calendar"></i></span>
          <span>{{ $t("calendar") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <patient-modal ref="patient_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import PatientModal from "./patient_modal/Index.vue";

export default {
  name: "PatientDatatable",
  components: { GenericTable, PatientModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("phone"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return row.phone || "";
          },
        },
        {
          title: v.$t("email"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return row.email || "";
          },
        },
        // {
        //   title: v.$t("balance"),
        //   searchable: false,
        //   width: "20%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row.account, null, 2)}</pre>`;
        //     if (
        //       row.account &&
        //       row.account.account &&
        //       row.account.account.balance
        //     ) {
        //       return format_currency(row.account.account.balance);
        //     } else {
        //       return "";
        //       // return v.$t("no account");
        //     }
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.patient_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("profile"),
                icon: "fa fa-user",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$router.push({
                    path: `/animal/${e.detail.uuid}`,
                  });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete patient?"),
                    v,
                    () => {
                      del("/animal", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.patient_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    go_calendar() {
      let v = this;
      v.$router.push({
        path: "/animal/calendar",
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
